import { getCardTheme } from "./cardTheme";

export const defaultCardsColor = "#1b8395";

export const normalizeColor = (value = defaultCardsColor) => {
  const trimmedValue = value.trim();
  return /^#[0-9a-f]{6}$/i.test(trimmedValue)
    ? trimmedValue
    : defaultCardsColor;
};

export const getAbsoluteCardUrl = (cardUrl = "") => {
  if (!cardUrl) {
    return "";
  }

  if (/^https?:\/\//i.test(cardUrl)) {
    return cardUrl;
  }

  if (typeof window === "undefined") {
    return cardUrl;
  }

  return `${window.location.origin}${cardUrl.startsWith("/") ? cardUrl : `/${cardUrl}`}`;
};

export const normalizeUrl = (value = "") => {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return "";
  }

  if (/^[a-z][a-z\d+.-]*:\/\//i.test(trimmedValue)) {
    return trimmedValue;
  }

  if (trimmedValue.startsWith("//")) {
    return `https:${trimmedValue}`;
  }

  return `https://${trimmedValue}`;
};

export const getPhoneValue = (data, fieldName, prefixFieldName) => {
  const phone = data?.[fieldName] || "";
  const prefix = data?.[prefixFieldName] || "";

  if (!phone) {
    return "";
  }

  return phone.trim().startsWith("+") || !prefix ? phone : `${prefix}${phone}`;
};

export const getFullName = (card = {}) =>
  `${card.firstName || ""} ${card.lastName || ""}`.trim();

export const getCardToolData = ({ card = {}, cardUrl = "" }) => {
  const fullName = getFullName(card);
  const theme = getCardTheme(card);
  const normalizedCardUrl = getAbsoluteCardUrl(cardUrl || card.slug || "");
  const website = normalizeUrl(card.website || "");
  const mobile = getPhoneValue(card, "mobile", "mobilePrefix");
  const phone = getPhoneValue(card, "phone", "phonePrefix");
  const address = [card.address, card.zipCode, card.city]
    .filter(Boolean)
    .join(" ");

  return {
    ...card,
    fullName,
    displayName: fullName || card.companyName || "Cards",
    cardUrl: normalizedCardUrl,
    primaryColor: theme.colors.primary,
    website,
    mobile,
    phone,
    address,
  };
};
